import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DashboardLayout } from '../../components/DashboardLayout';
import { LayoutDashboard, Shield, MessageSquare, Settings, Eye, Clock, Edit, Trash2, AlertCircle } from 'lucide-react';
import { ConfirmModal } from '../../components/modals/ConfirmModal';
import { MessageModal } from '../../components/modals/MessageModal';
export function MyAdvocacyPostsPage() {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState<number | null>(null);
  const [statusFilter, setStatusFilter] = useState('All Status');
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard'
  }, {
    label: 'My Advocacy',
    icon: Shield,
    path: '/advocacy/my-posts'
  }, {
    label: 'My Inquiries',
    icon: MessageSquare,
    path: '/buyer/inquiries'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/buyer/settings'
  }];
  const posts = [{
    id: 1,
    title: 'Delayed Possession - 18 Months Overdue',
    project: 'Green Valley Phase 2',
    category: 'Possession Delay',
    status: 'Live',
    submittedDate: '2024-01-15',
    approvedDate: '2024-01-15',
    views: 234,
    comments: 12,
    moderatorNotes: null
  }, {
    id: 2,
    title: 'No Water Connection After 3 Years',
    project: 'Lake View Plots',
    category: 'Infrastructure',
    status: 'Under Review',
    submittedDate: '2024-01-20',
    approvedDate: null,
    views: 0,
    comments: 0,
    moderatorNotes: 'Under moderation review. Expected approval within 6 hours.'
  }, {
    id: 3,
    title: 'Missing Amenities as Promised',
    project: 'Sunrise Heights',
    category: 'Infrastructure',
    status: 'Rejected',
    submittedDate: '2024-01-10',
    approvedDate: null,
    views: 0,
    comments: 0,
    moderatorNotes: 'Post rejected: Insufficient evidence provided. Please resubmit with supporting documents.'
  }, {
    id: 4,
    title: 'Builder Refusing OC Handover',
    project: 'Metro Residency',
    category: 'Documentation',
    status: 'Live',
    submittedDate: '2024-01-05',
    approvedDate: '2024-01-06',
    views: 189,
    comments: 8,
    moderatorNotes: null
  }];
  const filteredPosts = posts.filter(post => {
    return statusFilter === 'All Status' || post.status === statusFilter;
  });
  const handleDelete = (postId: number) => {
    setSelectedPost(postId);
    setIsDeleteModalOpen(true);
  };
  const confirmDelete = () => {
    setIsDeleteModalOpen(false);
    setIsMessageModalOpen(true);
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Live':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'Under Review':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'Rejected':
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }
  };
  return <DashboardLayout title="My Advocacy" personaLabel="BUYER" personaColor="bg-green-100 text-green-800 border-green-200" navItems={navItems} userInitials="JD" data-id="element-1798">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-1799">
        <div data-id="element-1800">
          <h1 className="text-2xl font-bold mb-1" data-id="element-1801">My Advocacy Posts</h1>
          <p className="text-gray-500 font-mono text-sm" data-id="element-1802">
            Manage your submitted advocacy posts and track their status
          </p>
        </div>
        <Link to="/advocacy/submit" className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-1803">
          <Shield className="w-4 h-4" data-id="element-1804" /> Submit New Post
        </Link>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8" data-id="element-1805">
        <div className="bg-white border border-gray-300 p-6" data-id="element-1806">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1807">
            Total Posts
          </h3>
          <div className="text-3xl font-bold" data-id="element-1808">{posts.length}</div>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-1809">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1810">
            Live
          </h3>
          <div className="text-3xl font-bold text-green-600" data-id="element-1811">
            {posts.filter(p => p.status === 'Live').length}
          </div>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-1812">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1813">
            Under Review
          </h3>
          <div className="text-3xl font-bold text-yellow-600" data-id="element-1814">
            {posts.filter(p => p.status === 'Under Review').length}
          </div>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-1815">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1816">
            Total Views
          </h3>
          <div className="text-3xl font-bold" data-id="element-1817">
            {posts.reduce((sum, p) => sum + p.views, 0)}
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white border border-gray-300 p-4 mb-6" data-id="element-1818">
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="px-4 py-2 border border-gray-300 bg-gray-50 text-sm font-medium focus:outline-none focus:border-gray-500" data-id="element-1819">
          <option data-id="element-1820">All Status</option>
          <option data-id="element-1821">Live</option>
          <option data-id="element-1822">Under Review</option>
          <option data-id="element-1823">Rejected</option>
        </select>
      </div>

      {/* Posts List */}
      <div className="space-y-4" data-id="element-1824">
        {filteredPosts.map(post => <div key={post.id} className="bg-white border border-gray-300 p-6" data-id="element-1825">
            <div className="flex items-start justify-between mb-4" data-id="element-1826">
              <div className="flex-1" data-id="element-1827">
                <div className="flex items-center gap-2 mb-3" data-id="element-1828">
                  <span className={`px-2 py-0.5 text-xs font-bold rounded border ${getStatusBadge(post.status)}`} data-id="element-1829">
                    {post.status.toUpperCase()}
                  </span>
                  <span className="px-2 py-0.5 bg-gray-100 text-gray-700 text-xs font-bold" data-id="element-1830">
                    {post.category}
                  </span>
                </div>
                <h3 className="text-lg font-bold mb-2" data-id="element-1831">{post.title}</h3>
                <p className="text-sm text-gray-600 mb-3" data-id="element-1832">{post.project}</p>

                {post.moderatorNotes && <div className="p-3 bg-yellow-50 border border-yellow-200 flex gap-3 mb-3" data-id="element-1833">
                    <AlertCircle className="w-5 h-5 text-yellow-600 shrink-0" data-id="element-1834" />
                    <div data-id="element-1835">
                      <p className="text-xs font-bold text-yellow-900 mb-1" data-id="element-1836">
                        Moderator Notes:
                      </p>
                      <p className="text-xs text-yellow-800" data-id="element-1837">
                        {post.moderatorNotes}
                      </p>
                    </div>
                  </div>}

                <div className="flex items-center gap-6 text-sm text-gray-500" data-id="element-1838">
                  <span className="flex items-center gap-1" data-id="element-1839">
                    <Clock className="w-4 h-4" data-id="element-1840" />
                    Submitted: {post.submittedDate}
                  </span>
                  {post.status === 'Live' && <>
                      <span className="flex items-center gap-1" data-id="element-1841">
                        <Eye className="w-4 h-4" data-id="element-1842" />
                        {post.views} views
                      </span>
                      <span className="flex items-center gap-1" data-id="element-1843">
                        <MessageSquare className="w-4 h-4" data-id="element-1844" />
                        {post.comments} comments
                      </span>
                    </>}
                </div>
              </div>

              <div className="flex gap-2" data-id="element-1845">
                {post.status === 'Live' && <Link to={`/advocacy/post/${post.id}`} className="p-2 border border-gray-300 hover:bg-gray-50" title="View Post" data-id="element-1846">
                    <Eye className="w-4 h-4 text-gray-600" data-id="element-1847" />
                  </Link>}
                {post.status === 'Rejected' && <Link to={`/advocacy/submit?resubmit=${post.id}`} className="p-2 border border-gray-300 hover:bg-gray-50" title="Resubmit" data-id="element-1848">
                    <Edit className="w-4 h-4 text-gray-600" data-id="element-1849" />
                  </Link>}
                <button onClick={() => handleDelete(post.id)} className="p-2 border border-red-300 hover:bg-red-50" title="Delete" data-id="element-1850">
                  <Trash2 className="w-4 h-4 text-red-600" data-id="element-1851" />
                </button>
              </div>
            </div>
          </div>)}
      </div>

      {filteredPosts.length === 0 && <div className="bg-white border border-gray-300 p-12 text-center" data-id="element-1852">
          <Shield className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-1853" />
          <p className="text-gray-500 font-mono mb-4" data-id="element-1854">No posts found</p>
          <Link to="/advocacy/submit" className="inline-block px-6 py-3 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-1855">
            Submit Your First Post
          </Link>
        </div>}

      <ConfirmModal isOpen={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)} onConfirm={confirmDelete} title="Delete Advocacy Post" message="Are you sure you want to delete this post? This action cannot be undone." confirmText="Delete" type="danger" data-id="element-1856" />

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Post Deleted" message="Your advocacy post has been successfully deleted." type="success" data-id="element-1857" />
    </DashboardLayout>;
}